import React from "react";
import { colors, gradients, typography, iconBox, transition } from "../theme";

const StatCard = ({
  icon,
  iconBg,
  label,
  value,
  valueColor,
  suffix,
  onClick,
  active,
}) => (
  <div
    className="d-flex align-items-center p-3 rounded flex-grow-1"
    onClick={onClick}
    style={{
      background: active ? colors.primary.bg : colors.bg.white,
      border: active
        ? `2px solid ${colors.primary.border}`
        : `1px solid ${colors.border.default}`,
      gap: 12,
      minWidth: 0,
      cursor: onClick ? "pointer" : "default",
      transition,
    }}
  >
    <div style={iconBox(40, iconBg)}>
      <i
        className={`fa ${icon}`}
        style={{ fontSize: 16, color: colors.text.white }}
      />
    </div>
    <div style={{ minWidth: 0 }}>
      <div style={typography.label}>{label}</div>
      <div
        style={{
          fontSize: 20,
          fontWeight: 800,
          color: valueColor || colors.text.primary,
          lineHeight: 1.2,
        }}
      >
        {value}
        {suffix && (
          <span
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: colors.text.muted,
              marginLeft: 4,
            }}
          >
            {suffix}
          </span>
        )}
      </div>
    </div>
  </div>
);

const EpSessionStatsBar = ({ stats, filterProps }) => {
  const progressPercent =
    stats.total > 0
      ? Math.round((stats.decisionsTaken / stats.total) * 100)
      : 0;

  return (
    <div data-tour="stats-bar" className="mb-3">
      <div className="d-flex flex-wrap" style={{ gap: 10 }}>
        <StatCard
          icon="fa-users"
          iconBg={gradients.indigo}
          label="Total allocataires"
          value={stats.total}
        />
        <StatCard
          icon="fa-check-circle"
          iconBg={
            progressPercent === 100 ? gradients.success : gradients.warning
          }
          label="Décisions prises"
          value={`${stats.decisionsTaken} / ${stats.total}`}
          valueColor={progressPercent === 100 ? colors.success.dark : "#d97706"}
          active={filterProps?.filterDecision === "with"}
          onClick={() => {
            if (!filterProps) return;
            filterProps.setFilterType("");
            filterProps.setFilterDecision(
              filterProps.filterDecision === "with" ? "" : "with",
            );
          }}
        />
        <StatCard
          icon="fa-pause-circle"
          iconBg={gradients.warning}
          label="Suspensions"
          value={stats.suspensions}
          valueColor={colors.warning.text}
          active={filterProps?.filterType === "SUSPENSION"}
          onClick={() => {
            if (!filterProps) return;
            filterProps.setFilterDecision("");
            filterProps.setFilterType(
              filterProps.filterType === "SUSPENSION" ? "" : "SUSPENSION",
            );
          }}
        />
        <StatCard
          icon="fa-times-circle"
          iconBg={gradients.danger}
          label="Suppressions"
          value={stats.suppressions}
          valueColor={colors.danger.text}
          active={filterProps?.filterType === "SUPPRESSION"}
          onClick={() => {
            if (!filterProps) return;
            filterProps.setFilterDecision("");
            filterProps.setFilterType(
              filterProps.filterType === "SUPPRESSION" ? "" : "SUPPRESSION",
            );
          }}
        />
      </div>
      {/* Progress bar */}
      <div className="mt-2 d-flex align-items-center" style={{ gap: 10 }}>
        <div
          className="flex-grow-1 rounded"
          style={{
            height: 6,
            background: colors.border.default,
            overflow: "hidden",
          }}
        >
          <div
            className="rounded"
            style={{
              height: "100%",
              width: `${progressPercent}%`,
              background:
                progressPercent === 100
                  ? gradients.progressComplete
                  : gradients.progressActive,
              transition: "width 0.5s ease",
            }}
          />
        </div>
        <span
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: colors.text.secondary,
            flexShrink: 0,
          }}
        >
          {progressPercent}%
        </span>
      </div>
    </div>
  );
};

export default React.memo(EpSessionStatsBar);
